/**
 * GlassPanel — Reusable pre-login glass panel.
 * Single hairline stroke, no ring. Backdrop blur + translucent fill + soft shadow.
 */

import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface GlassPanelProps {
  children: ReactNode;
  className?: string;
}

const glassPanelClasses =
  "relative rounded-2xl overflow-hidden " +
  "bg-white/60 dark:bg-white/[0.08] " +
  "backdrop-blur-xl " +
  "border border-white/40 dark:border-white/20 " +
  "shadow-[0_20px_60px_-30px_rgba(0,0,0,0.25)] dark:shadow-[0_20px_60px_-30px_rgba(0,0,0,0.4)] " +
  "before:content-[''] before:absolute before:inset-0 before:rounded-2xl before:pointer-events-none before:opacity-60 " +
  "before:bg-gradient-to-b before:from-white/40 before:to-transparent dark:before:from-white/10 dark:before:to-transparent";

export function GlassPanel({ children, className }: GlassPanelProps) {
  return (
    <div className={cn(glassPanelClasses, className)}>
      {children}
    </div>
  );
}
